// Reporte de clientes

import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Paper,
  Typography,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { format, subDays } from 'date-fns';
import { apiFetchJson } from '../fetchWrapper';
import ClientSelector from './ClientSelector';
import { formatMX } from '../util/DateUtil';
import jsPDF from "jspdf";
import DownloadIcon from '@mui/icons-material/Download';

export default function ReportClients() {
  const [startDate, setStartDate] = useState(subDays(new Date(), 7));
  const [endDate, setEndDate] = useState(new Date());
  const [clientId, setClientId] = useState(null);
  const [report, setReport] = useState(null);
  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleExport = () => {
    const doc = new jsPDF();

    // HEADER
    doc.setFontSize(16);
    doc.text("Reporte por Cliente", 14, 20);

    doc.setFontSize(10);
    doc.text(
      `Periodo: ${formatMX(startDate)} - ${formatMX(endDate)}`,
      14,
      30
    );

    // CLIENT KPIs
    doc.setFontSize(12);
    doc.text(`Cliente ID: ${report.clientId}`, 14, 45);

    doc.text(`Turnos totales: ${report.totalShifts}`, 14, 55);
    doc.text(
      `Asistencia: ${report.attendanceRate?.toFixed(1) ?? 0}%`,
      14,
      65
    );
    doc.text(`Retardos: ${report.lateCount}`, 14, 75);
    doc.text(`Faltas: ${report.noShowCount}`, 14, 85);

    doc.setFontSize(14);
    doc.text("Desglose por sitio", 14, 105);

    // Tabla de ubicaciones
    let y = 120;

    doc.setFontSize(10);

    report.sites?.forEach((site) => {
      doc.text(
        `${site.siteName} | Turnos: ${site.totalShifts} | Asistencia: ${site.attendanceRate?.toFixed(
          1
        )}% | Faltas: ${site.noShowCount}`,
        14,
        y
      );

      y += 10;
      
      // Evitar cortes de página incorrectos
      if (y > 280) {
        doc.addPage();
        y = 20;
      }
    });

    doc.save(`reporte-cliente-${report.clientId}.pdf`);
  };

  useEffect(() => {
    if (!clientId) return;

    const fetchReport = async () => {
      setLoading(true);
      try {
        const start = format(startDate, 'yyyy-MM-dd');
        const end = format(endDate, 'yyyy-MM-dd');

        const data = await apiFetchJson(
          `/api/reports/clients?clientId=${clientId}&startDate=${start}&endDate=${end}`
        );
        console.log('Report data', data);
        setReport(data);
      } catch (err) {
        console.error('Failed to load client report', err);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [clientId, startDate, endDate]);

  const siteRows = report?.sites || [];

  return (
    <Box>

      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        mb: 2,
        mr: 5
      }}>
        <Typography>Reporte por cliente</Typography>

        <Box
          sx={{
            flex: 1,
            minWidth: 200
          }}>
          <ClientSelector onSelectClientId={setClientId} />           
        </Box>

        <Button
          variant="outlined"
          startIcon={<DownloadIcon />}
          onClick={handleExport}
          sx={{
            height: 40,
            whiteSpace: 'nowrap',
          }}
        >
          Exportar PDF
        </Button>
      </Box>

      {/* filtros de fechas */}
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <Button variant="outlined" onClick={() => setStartDate(subDays(new Date(), 7))}>
          Últimos 7 días
        </Button>

        <Button variant="outlined" onClick={() => setStartDate(subDays(new Date(), 30))}>
          Últimos 30 días
        </Button>

        <Typography>
          {format(startDate, 'yyyy-MM-dd')} → {format(endDate, 'yyyy-MM-dd')}
        </Typography>
      </Box>

      {/* CARDS */}
      <Grid container spacing={2} sx={{ mb: 3, mr: 1 }}>
        {[
    { label: 'Turnos', value: report?.totalShifts ?? 0 },
    { label: 'Asistencia', value: `${report?.attendanceRate?.toFixed(1) ?? 0}%` },
    { label: 'Retardos', value: report?.lateCount ?? 0 },
    { label: 'Faltas', value: report?.noShowCount ?? 0 },
  ].map((card, i) => (
    <Grid
      item
      xs={12}
      sm={6}
      md
      key={i}
      sx={{ flexGrow: 1 }}
    >
      <Paper sx={{ p: 2, height: '100%' }}>
        <Typography variant="subtitle2">{card.label}</Typography>
        <Typography variant="h5">{card.value}</Typography>
      </Paper>
    </Grid>
  ))}
      </Grid>


          <Box>
            <Typography>
              Lista por ubicación
            </Typography>
           </Box> 

        <TableContainer component={Paper} sx={{ p: 1 }}>
          <Table>
            <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
              <TableRow>
                <TableCell>Ubicación</TableCell>
                <TableCell>Turnos</TableCell>
                <TableCell>Asistencia</TableCell>
                <TableCell>Retardos</TableCell>
                <TableCell>Faltas</TableCell>
                <TableCell>Overtime</TableCell>
              </TableRow>
            </TableHead>



            <TableBody>
              {siteRows.map((site) => (
                <TableRow key={site.siteId}>
                  <TableCell>{site.siteName}</TableCell>
                  <TableCell>{site.totalShifts}</TableCell>
                  <TableCell>{site.attendanceRate?.toFixed(1)}%</TableCell>
                  <TableCell>{site.lateCount}</TableCell>
                  <TableCell>{site.noShowCount}</TableCell>
                  <TableCell>{site.overtimeCount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
  
    </Box>
  );
}